<div class="lite-json-editor">
    <div
        #editor
        class="ant-input lite-json-editor-content"
        [ngStyle]="dark ? { background: '#202740', color: '#ffffff' } : {}"
        [contentEditable]="!withoutEdit"
        (input)="onEditorInput($event)"
        (blur)="onTouched()"
    ></div>
    <div *ngIf="!withoutError" class="error-popup">Incorrect JSON format</div>
</div>
